import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  constructor(private http: HttpClient) { }  

  registerConsumer(body: any): Observable<any> {
    return this.http.post<any>(
      `${environment.CASHBACK_API}ConsumerBenefit`,
      body  
    )
  }
}
